module.exports = __webpack_public_path__ + "img/menu_bars.ca3abc67.svg";